import styles from "./DeactiveDeviceModal.module.scss";
import close from "../../../assets/icons/close.svg";
import Button from "../../button/Button";
import { useTranslation } from "react-i18next";
import { deviceProps } from "../../../types/details-api-types"; // Ensure you have the correct path and type
import { useSetDeactivateDeviceMutation } from "../../../store/services/details-api"; // Ensure you have the correct path
import { useEffect, useState } from "react";
import { trackEvent } from "../../../utils/analytics";
import { EVENT_NAMES } from "../../../types/event-names";

interface DeactiveDeviceModalProps {
  setIsModalDeactivateVisible: (arg: boolean) => void;
  setDeactivateSuccess: (arg: boolean) => void;
  setDeactivateDeviceItem: (arg: deviceProps | null) => void;
  deviceItem?: deviceProps | null;
  updateDevicesTable?: () => void;
  isLoadingDeactivate?: boolean;
  setIsLoadingDeactivate?: (arg0: boolean) => void;
}

const DeactiveDeviceModal: React.FC<DeactiveDeviceModalProps> = ({
  setIsModalDeactivateVisible: setIsModalDeactiveVisible,
  setDeactivateSuccess,
  setDeactivateDeviceItem,
  deviceItem,
  updateDevicesTable,
  isLoadingDeactivate,
  setIsLoadingDeactivate,
}) => {
  const [updateDeactivateDevice] = useSetDeactivateDeviceMutation();
  const [error, setError] = useState(false);

  const onClickHandler = async () => {
    setError(false);

    if (deviceItem?.machine_id && deviceItem?.os_name && deviceItem?.licenses[0].id) {
      const deviceDeactivateObj = {
        machine_id: deviceItem?.machine_id,
        os: deviceItem?.os_name,
        license_id: deviceItem.licenses[0].id,
      };

      trackEvent(EVENT_NAMES.DEVICE_DEACTIVATION_CONFIRMED);

      if (setIsLoadingDeactivate) {
        setIsLoadingDeactivate(true);
      }
      try {
        await updateDeactivateDevice(deviceDeactivateObj).unwrap();
        setDeactivateDeviceItem(null);

        if (updateDevicesTable) {
          updateDevicesTable();
        }
        setDeactivateSuccess(true);
        trackEvent(EVENT_NAMES.DEVICE_DEACTIVATION_SUCCESS);
      } catch (error) {
        console.error("Error deactivating device:", error);
        setError(true);
        trackEvent(EVENT_NAMES.DEVICE_DEACTIVATION_ERRORED);
      } finally {
        if (!isLoadingDeactivate) {
          setIsLoadingDeactivate && setIsLoadingDeactivate(false);
          setIsModalDeactiveVisible(false);
        }
      }
    } else {
      console.error("Device item or required properties are missing");
      trackEvent(EVENT_NAMES.DEVICE_DEACTIVATION_ERRORED);
    }
  };

  const { t } = useTranslation();

  useEffect(() => {
    trackEvent(EVENT_NAMES.DEVICE_DEACTIVATION_INITIATED, {
      deviceType: deviceItem?.os_name,
    });
  }, [deviceItem]);
  return (
    <div className={styles.root}>
      <div className={styles.root_header}>
        <p className={styles.root_header_title}>{t("Deactivate Fortect on This Device?")}</p>
        <img
          src={close}
          alt="close"
          onClick={() => {
            trackEvent(EVENT_NAMES.DEVICE_DEACTIVATION_CANCELLED, {});
            setIsModalDeactiveVisible(false);
          }}
          className={styles.root_header_img}
        />
      </div>
      <div className={styles.root_main}>
        <p className={styles.root_main_text}>
          {t("By deactivating Fortect on this device, you'll be able to use your license on a different device.")}
        </p>
        <p className={styles.root_main_text}>
          {t(
            "Please note that once deactivated, this device will no longer have access to Fortect Premium, until you reactivate the license on it."
          )}
        </p>

        {error && (
          <p className={styles.root_main_text_error}>
            {t("Deactivation failed, try again. Contact support if issue persists")}
          </p>
        )}
      </div>
      <div className={styles.root_footer}>
        <Button
          onClick={onClickHandler}
          text={t("Confirm Deactivation")}
          isLoader={isLoadingDeactivate}
          classNames={styles.root_footer_confirm}
        />

        <Button
          onClick={() => {
            trackEvent(EVENT_NAMES.DEVICE_DEACTIVATION_CANCELLED, {});
            setIsModalDeactiveVisible(false);
          }}
          text={t("Cancel")}
          type="default"
          classNames={styles.root_footer_cancel}
        />
      </div>
    </div>
  );
};

export default DeactiveDeviceModal;
